var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.172 18.238H4.275c-.443 0-.797.39-.797.878 0 .487.354.877.797.877h5.2M12.707 10.145c1.157 0 2.1-1.037 2.1-2.312V3l-2.214.947c-1.196.516-1.987 1.017-1.987 2.424v1.462c0 1.275.943 2.312 2.1 2.312zM15.516 7.067c.443.487 1.05.787 1.72.787h1.24c1.158 0 2.126-.843 2.372-2.375.07-.418-.221-.794-.607-.794h-1.48a.665.665 0 01-.576-.362c-.26-.495-.866-1.316-2.062-1.316h-1.31",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.365 10.236c-.101.55-.455 1.01-.936 1.205l-3.625 1.455c-1.246.53-2.125 1.867-2.125 3.427 0 2.034 1.499 3.677 3.34 3.677.057 0 .107 0 .164-.007V20h4.106c.152 0 .272-.132.272-.3 0-.8-.595-1.455-1.322-1.455h-.367a3.96 3.96 0 00.493-1.922c0-.488-.088-.954-.247-1.386M16.623 8.996v.99c1.012.529 1.708 1.657 1.708 2.973 0 1.477-.886 2.73-2.107 3.141v2.138h.785c.727 0 1.322.655 1.322 1.456 0 .167-.12.3-.272.3h-2.442c-.62 0-1.126-.558-1.126-1.24v-2.647",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.272 5.159c0-.021.008-.05.032-.075a.18.18 0 01.133-.056c.062 0 .108.029.133.056a.113.113 0 01.032.075.113.113 0 01-.032.075.181.181 0 01-.133.056.181.181 0 01-.133-.056.113.113 0 01-.032-.075z",
    fill: "#222",
    stroke: "#222",
    className: "stroke fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.e28e99d9.svg";
export { ForwardRef as ReactComponent };